import { render, staticRenderFns } from "./IconUser.vue?vue&type=template&id=3f3db2d7&"
import script from "./IconUser.vue?vue&type=script&lang=js&"
export * from "./IconUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports